import { IconContainer, Wrapper } from './ProductPointsBadge.styles'
import Icon from '../components/Icons'
import { ProductPointsBadgeProps } from '@/types'

const ProductPointsBadge: React.FC<ProductPointsBadgeProps> = ({
  icon,
  points,
  description = 'Points',
  style = { padding: '5px 7px', borderRadius: '3px' },
}) => {
  return (
    <Wrapper data-testid="product-tile-badge-points" style={style}>
      {icon && (
        <IconContainer data-testid="product-tile-badge-points-icon-container">
          <Icon name={icon} height={15} width={15} />
        </IconContainer>
      )}
      Earn {points.toLocaleString('en-AU')} {description}
    </Wrapper>
  )
}

export default ProductPointsBadge
